module.exports = __webpack_public_path__ + "static/media/anteraja.3189778b.png";